// Modal.tsx
import React from 'react';

interface ModalProps {
  isOpen: boolean;
  onClose: () => void;
  onSubmit: (rowId: string, columnId: string, originalValue: string, newValue: string) => void;
  rowId: string;
  columnId: string;
  originalValue: string; // New prop for the original value
}


const Modal: React.FC<ModalProps> = ({ isOpen, onClose, onSubmit, rowId, columnId, originalValue }) => {
  const [inputValue, setInputValue] = React.useState('');

  if (!isOpen) return null;

  const handleSubmit = () => {
    onSubmit(rowId, columnId, originalValue, inputValue); // Pass original value and new input value
    setInputValue('');
    onClose();
  };

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-white p-4 rounded shadow-lg">
        <h2 className="text-lg font-bold">Report Incorrect Value</h2>
        <input
          type="text"
          value={inputValue}
          onChange={(e) => setInputValue(e.target.value)}
          className="border p-2 w-full mt-2"
          placeholder="Enter the correct value"
        />
        <div className="mt-4 flex justify-end">
          <button onClick={onClose} className="mr-2 bg-gray-300 p-2 rounded">
            Cancel
          </button>
          <button onClick={handleSubmit} className="bg-blue-500 text-white p-2 rounded">
            Submit
          </button>
        </div>
      </div>
    </div>
  );
};

export default Modal;